module.exports = __webpack_public_path__ + "img/vw-logo.5003fc60.svg";